import React from 'react';
import { useTranslation } from 'react-i18next';
import EnhancedGifPlayer from './EnhancedGifPlayer';
import { images } from '@/assets/images';

export default function OpCatStory() {
  const { t } = useTranslation();
  
  return (
    <section className="relative bg-dark py-8 sm:py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))]
          from-primary/5 via-transparent to-transparent"></div>
        {[...Array(10)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-primary/30 rounded-full animate-twinkle will-change-transform"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`
            }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-16">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4">
            <span className="text-transparent bg-clip-text bg-gradient-to-r 
              from-primary via-primary-light to-primary animate-gradient-x">
              {t('story.title')}
            </span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 sm:gap-16 items-center">
          <div className="space-y-4 sm:space-y-8">
            <div className="card group hover:bg-dark-lighter/50">
              <p className="text-xl text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{
                __html: t('story.description', { developer: '<span class="text-primary font-mono bg-primary/10 px-2 py-1 rounded">Kektoshi</span>' })
              }} />
            </div>

            <div className="card group hover:bg-dark-lighter/50">
              <p className="text-xl text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{
                __html: t('story.community', { platform: '<span class="text-primary font-mono bg-primary/10 px-2 py-1 rounded">Magic Eden</span>' })
                  .replace(/staking platform/g, '<span class="text-primary">staking platform</span>')
                  .replace(/explorer/g, '<span class="text-primary">explorer</span>')
              }} />
            </div>

            <div className="card group hover:bg-dark-lighter/50">
              <p className="text-xl text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{
                __html: t('story.conclusion')
                  .replace(/100%/g, '<span class="text-primary">100%</span>')
                  .replace(/community-driven/g, '<span class="text-primary">community-driven</span>')
              }} />
            </div>
          </div>

          <div className="relative flex items-center justify-center">
            <div className="absolute -inset-1 bg-gradient-to-r from-primary to-primary-light 
              rounded-2xl blur-xl opacity-20 animate-pulse"></div>
            <div className="relative card overflow-hidden group hover:bg-dark-lighter/50 p-4 sm:p-8">
              <div className="relative aspect-square flex items-center justify-center">
                <div className="w-[240px] h-[240px] sm:w-[320px] sm:h-[320px] md:w-[360px] md:h-[360px] p-4">
                  <EnhancedGifPlayer
                    src={images.nodeRocks.traits}
                    alt="NodeRocks Traits"
                    className="w-full h-full object-contain rounded-lg animate-bounce-slow group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}